module.exports = __webpack_public_path__ + "static/media/eth-round-landing.fa93630e.svg";